import { percentValue } from "../../helpers/operationMath";

export const ContainerCardsSizeProject = ({ data = [], extraClass = "" }) => {
	// Sumamos todos los proyectos
	const totalProyects = data.reduce((total, child) => total + (child.value || 0), 0);
	return (
		<section className={`w-full grid grid-cols-[repeat(auto-fit,_minmax(152px,_1fr))] gap-6 ${extraClass}`}>
			{data.map((child, index) => {
				let color = child.color ? child.color : "#ccc";
				let percentage = percentValue(totalProyects, child.value);

				return (
					<div key={`${index}-categories`} className="rounded-md  border-2 border-[#EFF2F5]">
						<div className="flex justify-between px-3 py-2 bg-[#EFF2F5]">
							<div className="flex gap-3">
								<div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }} />
								<p className="text-xs font-bold">{child.label}</p>
							</div>
						</div>
						<div className="flex justify-between py-[6px] px-3 text-[10px]">
							<p>
								<span className="font-semibold">{child.value}</span> proyectos
							</p>
							<p className="font-semibold">{percentage}%</p>
						</div>
					</div>
				);
			})}
		</section>
	);
};
